import React from 'react';
import cx from 'classnames';

import styles from './babyErrorPage.module.less';
import { Title2 } from '../../typography/Headings';
import { BodyBase } from '../../typography/Paragraphs';
import Meltdown from './meltdown.webp';
import { LinkV2 } from '../LinkV2';

export type BabyErrorPageProps = React.HTMLAttributes<HTMLDivElement>;

/**
 * The content for a baby error page.  Client apps (web-baby/web-wedding/web-registry)
 * should wrap this content in the nav and appropriate footer.
 */
export const BabyErrorPage = ({ className, ...rest }: BabyErrorPageProps) => {
  return (
    <div className={cx(styles.babyErrorPage, className)} {...rest}>
      <div className={styles.body}>
        <Title2 strong>This page is having a meltdown</Title2>
        <BodyBase>
          While we grab it a snack and tuck it in for a nap, use the links below to return to the
          party.
        </BodyBase>
        <LinkV2 arrow arrowPosition="postfix" href="/search/baby-registry" noUnderline>
          Search for a baby registry
        </LinkV2>
        <LinkV2 arrow arrowPosition="postfix" href="/onboard" noUnderline>
          Start a registry
        </LinkV2>
      </div>
      <img src={Meltdown} alt="A baby being comforted by a parent while crying" />
    </div>
  );
};

export default BabyErrorPage;
